import { Component, OnInit } from "@angular/core";
import { DatePipe } from "@angular/common";
import { ReportingCorporateService } from '../core/service/reporting-corporate.service';

@Component({
  selector: 'app-extraction-corporate',
  templateUrl: './extraction-corporate.component.html',
  styleUrls: ['./extraction-corporate.component.scss']
})
export class ExtractionCorporateComponent implements OnInit {

  debut: any = null;
  fin: any = null;

  constructor(
    private datePipe: DatePipe,
    private _reportingService: ReportingCorporateService
  ) {}

  ngOnInit() {}

  exportDossiers() {
    let deb = this.datePipe.transform(this.debut, "yyyy-MM-ddTHH:mm:ss") || "";
    let fn = this.datePipe.transform(this.fin, "yyyy-MM-ddTHH:mm:ss") || "";

    this._reportingService.exportDossiers(deb, fn).subscribe((blob) => {
      let fileUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", "dossiers-" + deb + ".xlsx");
      document.body.appendChild(link);
      link.click();
    });
  }

}
